const reportMessages = {
  'report.header.title': '報告書一覧',
  'report.list.action.description': 'チェックした項目を',
  'report.list.action.download': 'ダウンロード',
  'report.list.header.number': '報告書No',
  'report.list.header.subject': '件名',
  'report.list.header.status': 'ステータス',
  'report.list.header.author': '作成者',
  'report.list.header.createDate': '作成日',
  'report.list.header.lastModifiedBy': '最終更新者',
  'report.list.header.lastModifiedDate': '最終更新日時',
  'report.pagination.unit': '件',
  'report.detail.title': '報告書詳細',
  'report.detail.section.title': '報告書プレビュー',
  'report.detail.url.copy': 'URLコピー',
  'report.detail.url.copy.complete': 'URLをコピーしました。',
  'report.detail.info.number': '報告書No',
  'report.detail.info.subject': '件名',
  'report.detail.info.status': 'ステータス',
  'report.detail.info.views': '閲覧数',
  'report.detail.info.unit': ' 件',
  'report.detail.info.author': '作成者',
  'report.detail.info.creationDate': '作成日',
  'report.detail.info.lastUpdatedBy': '最終更新者',
  'report.detail.info.lastUpdatedDate': '最終更新日',
  'report.detail.pdf.error': 'PDFファイルの読み込みに失敗しました。',
  'report.edit.header.title': '報告書編集',
  'report.edit.header.lastModifiedDate': '最終更新日時',
  'report.edit.header.status': 'ステータス',
  'report.edit.action.return': '一覧へ戻る',
  'report.edit.action.preview': 'プレビュー',
  'report.edit.action.statusChange': '変更',
  'report.edit.info.number': '報告書No.',
  'report.edit.info.subject': '報告書件名',
  'report.edit.info.author': '作成者',
  'report.edit.info.creationDate': '作成日',
  'report.edit.info.picture.placeholder': 'クリックして写真を選ぼう',
  'report.edit.info.picture.noImages': 'No Images',
  'report.edit.status.confirmation.header': '報告書を{statusName}にする',
  'report.edit.status.confirmation.message.published':
    '報告書をメンバーに共有しますがよろしいですか？',
  'report.edit.status.confirmation.message.complete':
    '報告書を完了にすると編集できなくなりますがよろしいですか？',
  'report.edit.status.confirmation.button.ok': '{statusName}にして保存',
  'report.status.create': '下書き',
  'report.status.published': '共有',
  'report.status.complete': '完了',
};

export default reportMessages;
